import { render, staticRenderFns } from "./UploadVideoSidebar.vue?vue&type=template&id=178f6850&scoped=true&"
import script from "./UploadVideoSidebar.vue?vue&type=script&lang=js&"
export * from "./UploadVideoSidebar.vue?vue&type=script&lang=js&"
import style0 from "./UploadVideoSidebar.vue?vue&type=style&index=0&id=178f6850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178f6850",
  null
  
)

export default component.exports